import { useEffect, useState } from "react";
import BasicDropdown from "../ui/forms/dropdown/BasicDropdown";
import { ImageUpload } from "../ui/forms/files/ImageUpload";
import { toLeagueOption } from "../ui/forms/dropdown/ddLabels";
import { getDDLeagueNames } from "../../services/leaguesAPI";
import { createTeam, updateTeam } from "../../services/teamsAPI";
import { toast } from "react-toastify";
import { Button } from "../ui/btns/Button";

// CREATE TEAM IS NOW USED FOR UDPATE ALSO
export const CreateTeam = ({ team, teamID, handleClose, fetchTeam }) => {
  const [isPending, setIsPending] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    city: "",
    description: "",
    league: null,
  });
  const [imageFile, setImageFile] = useState(null);
  // SET INITIAL DATA (FILL BY DEFAULT DATA FOR UPDATE)
  useEffect(() => {
    if (team) {
      setFormData({
        name: team.name || "",
        city: team.city || "",
        description: team.description || "",
        league: team.league
          ? { value: team.league, label: team?.LeagueDetails?.name }
          : null,
      });
    }
  }, [team]);

  const handleChange = (input) => {
    if (input.target) {
      const { name, value } = input.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      const { name, value } = input;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleImageInput = (file) => {
    setImageFile(file);
  };

  const handleDropdownChange = (selectedOption, name) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: selectedOption
        ? { value: selectedOption.value, label: selectedOption.label }
        : null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Valdate
    if (!formData.name || !formData.city || !formData.league) {
      toast.error("Name, city and league are required", { autoClose: 5000 });
      return;
    }
    const formDataToSend = new FormData();
    formDataToSend.append("league", formData.league ? formData.league.value : "");
    formDataToSend.append("city", formData.city);
    formDataToSend.append("name", formData.name);
    formDataToSend.append("description", formData.description);

    if (imageFile) {
      formDataToSend.append("image", imageFile);
    }

    setIsPending(true);

    let response;
    if (teamID) {
      response = await updateTeam(teamID, formDataToSend);
      if (!response?.success) {
        toast.error("Error updating team", { autoClose: 5000 });
        setIsPending(false);
        return;
      }
      toast.success("Team updated successfully");
      fetchTeam();
      handleClose();
      setIsPending(false);
    } else {
      response = await createTeam(formDataToSend);
      if (!response?.success) {
        toast.error("Error creating team", { autoClose: 5000 });
        setIsPending(false);
        return;
      }
      setIsPending(false);
      toast.success("Team created successfully");
      setFormData({
        name: "",
        city: "",
        description: "",
        league: null,
      });
    }
    console.log(response);
  };

  return (
    <div className="flex flex-col items-center justify-center p-6">
      <h1 className="font-heading text-xl font-black uppercase tracking-wide text-flyers-orange mb-4">
        {teamID ? "Update Team" : "Create Team"}
      </h1>
      <form
        onSubmit={handleSubmit}
        className="bg-flyers-charcoal border border-flyers-dark-gray p-6 rounded-lg w-full max-w-md"
      >
        <div className="mb-4">
          <label htmlFor="league" className="label">
            League
          </label>
          <BasicDropdown
            id="league"
            name="league"
            apiFunction={getDDLeagueNames}
            toOptionLabel={toLeagueOption}
            placeholder="Select a League"
            handleChange={handleDropdownChange}
            isSearchable={true}
            value={formData.league}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="city" className="label">
            City
          </label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="Team's City"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="name" className="label">
            Name
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Team's Name"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="description" className="label">
            Description
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter Description"
            className="input-new"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="image" className="label">
            Team Image
          </label>
          <ImageUpload labelText="Select Team Image" fileChange={handleImageInput} />
        </div>
        <Button variant="primary" type="submit" className="w-full" disabled={isPending}>
          {teamID ? "Update Team" : "Create Team"} {isPending && "..."}
        </Button>
      </form>
    </div>
  );
};
